import { useState } from "react";
import Button from "../Button";
import SectionTitle from "../SectionTitle";
import { Link } from "react-router-dom";
import { appPaths } from "../../Routes";
import ByRegionMeasuredCertainty from "./ByRegionMeasuredCertainty";
import {
    MeasuredEmissionSourceByRegion,
    NotMeasuredEmissionSourceByRegion,
} from "../../api/models/Dashboard";
import ByRegionNonMeasuredCertainty from "./ByRegionNonMeasuredCertainty";

type CertaintySectionProps = {
    measuredEmissionsSourcesByRegion: MeasuredEmissionSourceByRegion[];
    notMeasuredEmissionsSourcesByRegion: NotMeasuredEmissionSourceByRegion[];
};

const CertaintySection = ({
    measuredEmissionsSourcesByRegion,
    notMeasuredEmissionsSourcesByRegion,
}: CertaintySectionProps) => {
    const [view, setView] = useState<"measured" | "not-measured">("measured");

    return (
        <>
            <SectionTitle title="Certainty">
                <div className="flex flex-wrap sm:ml-auto gap-3 sm:space-y-0 mt-4">
                    <Button
                        className="whitespace-nowrap"
                        variant={view === "measured" ? "primary" : "outline"}
                        onClick={() => setView("measured")}
                    >
                        Measured
                    </Button>
                    <Button
                        className="whitespace-nowrap"
                        variant={
                            view === "not-measured" ? "primary" : "outline"
                        }
                        onClick={() => setView("not-measured")}
                    >
                        Not Measured
                    </Button>
                    <Link
                        className="block"
                        to={`${appPaths.emissionsSources(true)}&dataStatusEs=${
                            view === "measured" ? "3,4" : "1,2"
                        }`}
                    >
                        <Button variant="outline">View breakdown</Button>
                    </Link>
                </div>
            </SectionTitle>
            {view === "measured" ? (
                <ByRegionMeasuredCertainty
                    measuredEmissionsSourcesByRegion={
                        measuredEmissionsSourcesByRegion
                    }
                />
            ) : (
                <ByRegionNonMeasuredCertainty
                    notMeasuredEmissionsSourcesByRegion={
                        notMeasuredEmissionsSourcesByRegion
                    }
                    measuredEmissionsSourcesByRegion={
                        measuredEmissionsSourcesByRegion
                    }
                />
            )}
        </>
    );
};

export default CertaintySection;
